// extracted by mini-css-extract-plugin
export default {"noto":"home_noto__zLbLF","appbar":"home_appbar__dsdOT","awrlogo":"home_awrlogo__t+Qdf"};